<app-loader></app-loader>
<app-generic-loader [isLoader]="isLoading"></app-generic-loader>
<app-header-nav-bar style="--nav-header-img: url('/assets/images/common/Header.svg')">
  <app-header-brandlogo style="visibility: hidden"></app-header-brandlogo>

  <app-header-user-project-menu-list
    [active_line1]="ActiveModule1"
    [active_line2]="ActiveModule2"
    [active_line3]="ActiveModule3"
    [active_Menu]="'report'">
  </app-header-user-project-menu-list>

  <app-header-settings
    [settingIconShown]="true"
    [userManagementShown]="false"
    [excelExport]="excelExport"
    [helpGuide]="helpGuide"
    [pptExport]="pptExport"
    [repository]="repository"
    [exportDownloads]="exportDownloads">
  </app-header-settings>
</app-header-nav-bar>

<section (click)="closeAllDropdowns()">
  <div class="report-page-container">

    <!-- Search & Filter Section -->
    <div class="search-filter-container">
      <div class="search-filter-row">

        <!-- Search -->
        <div class="search-container">
          <div class="search-block" title="Search all except date/time">
            <div class="search-input-wrapper">
              <input
                type="text"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchInput($event)"
                class="search-input"
                placeholder="Search all except date/time" />
              <div class="search-icon"></div>
            </div>
          </div>
        </div>

        <!-- Module Filter (Multi-select) - COMMENTED OUT, MOVED TO COLUMN HEADERS -->
        <!--
        <div class="filter-dropdown">
          <label class="filter-label">Module</label>
          <div class="multiselect-wrapper" (click)="$event.stopPropagation()">
            <div
              class="multiselect-selected"
              (click)="toggleModuleDropdown()"
              [class.active]="showModuleDropdown">
              <span class="selected-text">{{ getModuleFilterText() }}</span>
              <span class="dropdown-arrow" [class.open]="showModuleDropdown">▼</span>
            </div>

            <div class="multiselect-options" *ngIf="showModuleDropdown">
              <div
                class="multiselect-option"
                (click)="clearModuleFilter()"
                *ngIf="selectedModules.length > 0">
                <span class="clear-all">Clear All</span>
              </div>

              <div
                class="multiselect-option"
                *ngFor="let module of allModules"
                (click)="toggleModuleSelection(module)">
                <input type="checkbox" [checked]="isModuleSelected(module)" readonly />
                <span>{{ formatModuleForDisplay(module) }}</span>
              </div>
            </div>
          </div>
        </div>
        -->

        <!-- Status Filter (Multi-select) - COMMENTED OUT, MOVED TO COLUMN HEADERS -->
        <!--
        <div class="filter-dropdown">
          <label class="filter-label">Status</label>
          <div class="multiselect-wrapper" (click)="$event.stopPropagation()">
            <div
              class="multiselect-selected"
              (click)="toggleStatusDropdown()"
              [class.active]="showStatusDropdown">
              <span class="selected-text">{{ getStatusFilterText() }}</span>
              <span class="dropdown-arrow" [class.open]="showStatusDropdown">▼</span>
            </div>

            <div class="multiselect-options" *ngIf="showStatusDropdown">
              <div
                class="multiselect-option"
                (click)="clearStatusFilter()"
                *ngIf="selectedStatuses.length > 0">
                <span class="clear-all">Clear All</span>
              </div>

              <div
                class="multiselect-option"
                *ngFor="let status of uniqueStatuses"
                (click)="toggleStatusSelection(status)">
                <input type="checkbox" [checked]="isStatusSelected(status)" readonly />
                <span>{{ status }}</span>
              </div>
            </div>
          </div>
        </div>
        -->

        <!-- Assigned To Filter (Multi-select) - COMMENTED OUT, MOVED TO COLUMN HEADERS -->
        <!--
        <div class="filter-dropdown">
          <label class="filter-label">Assigned To</label>
          <div class="multiselect-wrapper" (click)="$event.stopPropagation()">
            <div
              class="multiselect-selected"
              (click)="toggleAssigneeDropdown()"
              [class.active]="showAssigneeDropdown">
              <span class="selected-text">{{ getAssigneeFilterText() }}</span>
              <span class="dropdown-arrow" [class.open]="showAssigneeDropdown">▼</span>
            </div>

            <div class="multiselect-options" *ngIf="showAssigneeDropdown">
              <div
                class="multiselect-option"
                (click)="clearAssigneeFilter()"
                *ngIf="selectedAssignees.length > 0">
                <span class="clear-all">Clear All</span>
              </div>

              <div
                class="multiselect-option"
                *ngFor="let assignee of uniqueAssignees"
                (click)="toggleAssigneeSelection(assignee)">
                <input type="checkbox" [checked]="isAssigneeSelected(assignee)" readonly />
                <span>{{ assignee }}</span>
              </div>
            </div>
          </div>
        </div>
        -->

        <!-- Action Buttons -->
        <div class="action-buttons">
          <button
            class="action-btn export-btn"
            (click)="exportIncidentsToExcel()"
            title="Export Incidents">
            <img style="height: 0.9rem;"
              src="../../../assets/images/common/Save_icon_reportManagement.svg"
              alt="Export" />
            Export Incidents
          </button>

          <button
            class="action-btn clear-btn"
            [disabled]="!hasSelectedIncidents"
            (click)="deleteSelectedIncidents()"
            title="Delete Selected">
            <img style="height: 0.9rem;"
              src="../../../assets/images/common/trashicon.svg"
              alt="Delete" />
            Delete
          </button>
        </div>

      </div>
    </div>

    <!-- Div-based Table -->
    <div class="table-wrapper" (scroll)="onScroll($event)">
      <div class="div-table">

        <!-- Header Row -->
        <div class="div-table-header">
          <div class="div-table-row header-row">
            <div class="div-table-cell col-issue">
              <input
                type="checkbox"
                [checked]="isAllSelected"
                [indeterminate]="isIndeterminate"
                (change)="toggleSelectAll()" />
              Incident No.
            </div>
            <div class="div-table-cell col-client">Client Study</div>
            <div class="div-table-cell col-module header-filter-cell">
              <span class="header-filter-trigger" (click)="toggleModuleDropdown(); $event.stopPropagation()">
                Module <span class="arrow" [class.open]="showModuleDropdown">&#9662;</span>
              </span>
              <div *ngIf="showModuleDropdown" class="header-filter-dropdown" (click)="$event.stopPropagation()">
                <div class="multiselect-option" (click)="clearModuleFilter()" *ngIf="selectedModules.length > 0">
                  <span class="clear-all">Clear All</span>
                </div>
                <div class="multiselect-option" *ngFor="let module of allModules" (click)="toggleModuleSelection(module)">
                  <input type="checkbox" [checked]="isModuleSelected(module)" readonly />
                  <span>{{ formatModuleForDisplay(module) }}</span>
                </div>
              </div>
            </div>
            <div class="div-table-cell col-reported">Reported By</div>
            <div class="div-table-cell col-title">Report Title</div>

            <div
  class="div-table-cell col-date"
  style="position: relative; display: flex; align-items: center; flex-direction: row;"
>
  <span>Date Range</span>

  <span
    class="calendar-icon"
    (click)="showDatePicker = !showDatePicker; $event.stopPropagation()"
    style="cursor: pointer; margin-left: 2rem; display: flex; align-items: center;"
  >
    <img
      src="assets/images/common/calendar-icon.svg"
      alt="Calendar"
      width="18"
      height="18"
    />
  </span>

  <div
    *ngIf="showDatePicker"
    class="date-range-popup"
    (click)="$event.stopPropagation()"
  >
    <div class="date-range-content">
      <div class="date-field">
        <label class="date-label" for="startDate">Start Date</label>
        <input
          id="startDate"
          class="date-input"
          type="date"
          [(ngModel)]="startDate"
          (change)="onDateRangeChange()"
        />
      </div>
      <div class="date-field">
        <label class="date-label" for="endDate">End Date</label>
        <input
          id="endDate"
          class="date-input"
          type="date"
          [(ngModel)]="endDate"
          [min]="startDate"
          (change)="onDateRangeChange()"
          [disabled]="!startDate"
        />
      </div>
      <div class="date-actions">
        <button type="button" class="btn-clear" (click)="clearDateRange()">Clear</button>
      </div>
    </div>
  </div>
</div>

            <div class="div-table-cell col-status header-filter-cell">
              <span class="header-filter-trigger" (click)="toggleStatusDropdown(); $event.stopPropagation()">
                Status <span class="arrow" [class.open]="showStatusDropdown">&#9662;</span>
              </span>
              <div *ngIf="showStatusDropdown" class="header-filter-dropdown" (click)="$event.stopPropagation()">
                <div class="multiselect-option" (click)="clearStatusFilter()" *ngIf="selectedStatuses.length > 0">
                  <span class="clear-all">Clear All</span>
                </div>
                <div class="multiselect-option" *ngFor="let status of uniqueStatuses" (click)="toggleStatusSelection(status)">
                  <input type="checkbox" [checked]="isStatusSelected(status)" readonly />
                  <span>{{ status }}</span>
                </div>
              </div>
            </div>
            <div class="div-table-cell col-assigned header-filter-cell">
              <span class="header-filter-trigger" (click)="toggleAssigneeDropdown(); $event.stopPropagation()">
                Assigned To <span class="arrow" [class.open]="showAssigneeDropdown">&#9662;</span>
              </span>
              <div *ngIf="showAssigneeDropdown" class="header-filter-dropdown" (click)="$event.stopPropagation()">
                <div class="multiselect-option" (click)="clearAssigneeFilter()" *ngIf="selectedAssignees.length > 0">
                  <span class="clear-all">Clear All</span>
                </div>
                <div class="multiselect-option" *ngFor="let assignee of uniqueAssignees" (click)="toggleAssigneeSelection(assignee)">
                  <input type="checkbox" [checked]="isAssigneeSelected(assignee)" readonly />
                  <span>{{ assignee }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Body Rows -->
        <div class="div-table-body">
          <div
            class="div-table-row data-row"
            *ngFor="let incident of filteredIncidents"
            [class.selected-row]="incident.isSelected">

            <div class="div-table-cell col-issue">
              <input
                type="checkbox"
                [(ngModel)]="incident.isSelected"
                (change)="onIncidentSelectionChange()" />
              <span
                class="incident-number"
                (click)="openIncidentPopup(incident)">
               {{ incident.issueNo }}
              </span>
            </div>

            <div class="div-table-cell col-client" [title]="incident.clientStudy">
              <span
                [ngClass]="{'ellipsed': incident.clientStudy?.length > 15}"
                [attr.data-ellipsis]="incident.clientStudy?.length > 15 ? '...' : ''">
                {{ incident.clientStudy }}
              </span>
            </div>

            <div class="div-table-cell col-module">
              <span class="module-badge" [ngClass]="getModuleBadgeClass(incident.module)">
                {{ formatModuleForDisplay(incident.module) }}
              </span>
            </div>

            <div class="div-table-cell col-reported" [title]="incident.reportedBy">
              <span
                [ngClass]="{'ellipsed': incident.reportedBy?.length > 15}"
                [attr.data-ellipsis]="incident.reportedBy?.length > 15 ? '...' : ''">
                {{ incident.reportedBy }}
              </span>
            </div>

            <div
              class="div-table-cell col-title"
              [title]="incident.reportTitle"
              (click)="openIncidentPopup(incident)">
              <span
                [ngClass]="{'ellipsed': incident.reportTitle?.length > 20}"
                [attr.data-ellipsis]="incident.reportTitle?.length > 20 ? '...' : ''">
                {{ incident.reportTitle }}
              </span>
            </div>

            <div class="div-table-cell col-date">{{ incident.dateTime }}</div>

            <div class="div-table-cell col-status">
              <div class="status-cell-group">
                <div class="status-select-wrapper">
                  <select
                    [(ngModel)]="incident.status"
                    (change)="onStatusChange(incident)"
                    class="status-select status-ellipsis"
                    [title]="incident.status">
                    <option value="Client Education">Client Education</option>
                    <option value="New">New</option>
                    <option value="Work in Progress">Work in Progress</option>
                    <option value="Closed">Closed</option>
                  </select>
                  <span class="custom-arrow">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M4 6l4 4 4-4"
                        stroke="#888"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>

                <span class="status-icon" [ngClass]="incident.status">
                  <ng-container [ngSwitch]="incident.status">
                    <!-- New -->
                    <svg *ngSwitchCase="'New'" width="18" height="18" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="9" fill="#f44336" />
                      <circle cx="10" cy="10" r="3" fill="#fff" />
                    </svg>

                    <!-- Work in Progress -->
                    <svg *ngSwitchCase="'Work in Progress'" width="18" height="18" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="9" fill="#ff9800" />
                      <path
                        d="M10 6v4l2.5 2"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>

                    <!-- Closed -->
                    <svg *ngSwitchCase="'Closed'" width="18" height="18" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="9" fill="#4caf50" />
                      <path
                        d="M7 10.5l2 2 4-4"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>

                    <!-- Client Education -->
                    <svg *ngSwitchCase="'Client Education'" width="18" height="18" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="9" fill="#fff" stroke="#bdbdbd" stroke-width="1" />
                      <text
                        x="10"
                        y="14"
                        text-anchor="middle"
                        font-size="10"
                        fill="#bdbdbd"
                        font-family="Arial"
                        dy="-2">i</text>
                    </svg>

                    <!-- Default -->
                    <svg *ngSwitchDefault width="18" height="18" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="9" fill="#E0E0E0" />
                    </svg>
                  </ng-container>
                </span>
              </div>
            </div>

            <div class="div-table-cell col-assigned">
              <div class="assigned-to-group">
                <input
                  type="text"
                  [(ngModel)]="incident.assignedTo"
                  (blur)="onAssignedToChange(incident)"
                  class="assigned-to-input" />
                <button class="download-btn" (click)="downloadAttachment(incident)" title="Download Report Files">
                  <img src="assets/images/common/aesthetics/exportDownloadIcon.svg" alt="Download" />
                </button>
              </div>
            </div>
          </div>

          <!-- No Data Row -->
          <div class="div-table-row no-data-row" *ngIf="filteredIncidents.length === 0">
            <div class="div-table-cell no-data-cell">No incidents found</div>
          </div>
        </div>
      </div>
    </div>
<div class="FooterContainer custom-footer sticky-footer">
  <div class="warnings-block">
    <b>Note:</b> Click on <span style="font-weight:700; color:rgb(162, 40, 179);">Incident Number</span> or 
    <span style="font-weight:700; color:rgb(162, 40, 179);">Report Title</span> for more information.
  </div>
</div>


    <!-- Incident Popup -->
    <div
      *ngIf="showIncidentPopup && selectedIncident"
      class="popup-overlay"
      (click)="closeIncidentPopup()">
      <div (click)="$event.stopPropagation()">
        <app-report-issue-popup
          [readOnlyMode]="true"
          [incident]="selectedIncident"
          (closePopup)="closeIncidentPopup()"
          (downloadAllAttachments)="onDownloadAllIncidentAttachments(selectedIncident)"
        ></app-report-issue-popup>
      </div>
    </div>

  </div>
</section>
